import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export function useQueryState<S>(
	initialState: S, 
	key: string, 
	decoder?: (str: string) => S,
	encoder?: (obj: S) => string,
): [stateVar: S, stateVarSetter: (newState: S) => void] {
	const defaultDecoder = (str: string) => {
		try {
			return JSON.parse(str) as S
		} catch {
			return str as S;
		}
	};
	const defaultEncoder = (obj: S) => obj.toString();
	if (!decoder) decoder = defaultDecoder;
	if (!encoder) encoder = defaultEncoder;
	// const params = useSearchParams();
	const [searchParams, setSearchParams] = useSearchParams();
	
	const initVal = searchParams.get(key);
	const [stateVar, setStateVar] = useState<S>(initVal == null || typeof (initVal) === "undefined" ? initialState : decoder(initVal));
	const actualSetter = (newState: S) => {
		setSearchParams((params:URLSearchParams) => {
			const encoded = encoder(newState);
			if(encoded !== "" && encoded != null) {
				params.set(key, encoded);
			} else {
				params.delete(key);
			}
			return params;
		})
		setStateVar(newState);
	}
	return [stateVar, actualSetter];
}